import React, { Component } from "react";
import ReactModal from "react-modal";
import { apiUrl, apiUrl4 } from "../../config/config";
import axios from "axios";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import Loader from "react-loader-spinner";
import AnalyzingSpinner from "./AnalyzingSpinner";
import { start } from "@popperjs/core";
import { enqueue as enqueueAnalysis } from "./analysisQueue";

class AddModalComplete extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      showModalNew: false,
      showModalSpinner: false,
      clickdata: "",
      startProp: "",
      userid: "",
      showInputPopup: false,
      showInvertorpopup: false,
      showAnlayseone: false,
      showAnalysetwo: false,
      showAnalysethree: false,
      showAnalyzefour: false,
      inputValue: "",
      treemenu: [],
      treemenurev: [],
      starttime: "",
      endtime: "",
      lastindex: "",
      analyzeModal: "",
      showDeletePopup: false,
      showdatacopypopup: false,
      correctTime: "",
      showLoading: false,
      showSuccessModal: false,
      successMessage: "",
      showProgressModal: false,
      currentProgress: 0,
      progressInterval: null,
      progressComplete: false,
      showProgressPercent: false,
      analyzeServer: "Server 1",
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleCloseModalNew = this.handleCloseModalNew.bind(this);
    this.handleCloseModalSpinnerNew =
      this.handleCloseModalSpinnerNew.bind(this);
    this.handleDeletePopupClose = this.handleDeletePopupClose.bind(this);
    this.handleDeletePopupOk = this.handleDeletePopupOk.bind(this);
  }
  componentDidMount() {
    ReactModal.setAppElement("body");
    window.analyzeLink = "";
  }

  // Click handler for Analytics 2 image (no selection required)
  async handleAnalytics2Click() {
    const userId = this.state.userid;
    try {
      console.log("Preparing Analytics 2...");
      await this.resetProgress(userId);

      // If start/end not set from the popup, fall back to the clicked timestamp
      const fallback = this.state.clickdata ? this.state.clickdata.replace(/%20/g, " ") : "";
      const startdate = this.state.starttime && this.state.starttime.trim() !== "" ? this.state.starttime.replace(/%20/g, " ") : fallback;
      const enddate = this.state.endtime && this.state.endtime.trim() !== "" ? this.state.endtime.replace(/%20/g, " ") : fallback;

      const response = await axios.post(
        `${apiUrl4}api/common/Analyse_New_Modal1`,
        {
          userid: userId,
          databaseid: this.state.clickdata,
          startdate,
          enddate,
        },
        { timeout: 5 * 60 * 1000 }
      );
      console.log("Analyse_New_Modal1 response:", response.data);

      this.startProgressPolling(userId, "analytics2", 2000);
    } catch (err) {
      console.error("Error calling Analyse_New_Modal:", err);
      this.stopProgressPolling();
      this.setState({ showModalSpinner: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    //console.log(nextProps);
    console.log("AddModalComplete received props:", {
      clickdb: nextProps.clickdb,
      isOpen: nextProps.isOpen,
      userid: nextProps.userid,
      start: nextProps.start,
      startTime: nextProps.startTime,
      endTime: nextProps.endTime
    });
    
    const nextStart = nextProps.startTime || nextProps.start || "";
    const nextEnd = nextProps.endTime || "";
    const prevStart = this.props.startTime || this.props.start || "";
    const prevEnd = this.props.endTime || "";

    const shouldSyncTime = nextStart !== prevStart || nextEnd !== prevEnd;
    const shouldSyncCore =
      nextProps.clickdb !== this.props.clickdb ||
      nextProps.isOpen !== this.props.isOpen ||
      nextProps.userid !== this.props.userid ||
      nextProps.start !== this.props.start ||
      nextProps.startTime !== this.props.startTime ||
      nextProps.endTime !== this.props.endTime;

    if (!shouldSyncCore) return;

    this.setState({
      clickdata: nextProps.clickdb,
      showModal: nextProps.isOpen,
      userid: nextProps.userid,
      startProp: nextProps.start,
      ...(shouldSyncTime ? { starttime: nextStart, endtime: nextEnd } : {}),
    });
  }

  maybeReload(code) {
    const progressCodes = ["first-code", "second-code", "third-code", "fourth-code", "analytics2"];
    if (!progressCodes.includes(code)) {
      window.location.reload();
    }
  }
  handleCloseModal() {
    this.setState({ showModal: false });
    this.props.onResetModal();
  }

  handleCloseModalNew() {
    this.setState({ showModalNew: false });
    this.props.onResetModal();
  }
  handleCloseModalSpinnerNew() {
    this.setState({ showModalSpinner: false });
  }
  handleOpenModalSpinnerNew() {
    // Only open the lightweight spinner when the full progress modal is not shown
    if (!this.state.showProgressModal) {
      this.setState({ showModalSpinner: true });
    }
  }

  // Reset progress to 0 on server before starting an analysis
  async resetProgress(userId) {
    try {
      await axios.post(`${apiUrl}api/common/UpdateProgressStatus/${userId}`);
    } catch (err) {
      console.error('Failed to reset progress:', err);
    }
  }
  async openAnalyzemodal() {
    const response = await axios.get(
      `${apiUrl}api/common/patinentmenutreeNew?userid=${this.state.userid}`
    );
    // console.log('treemenu:!!!!!!!!!!',response.data)
    const treemenu = response.data;
    let optionnewon = []; // For ascending order
    let optionnewendon = []; // For descending order

    // Iterate over each date group in treemenu
    Object.keys(treemenu).forEach((dateKey) => {
      treemenu[dateKey].forEach((entry) => {
        const MainTimeon = entry.date.split("T");
        const timeon = MainTimeon[1].split("+")[0]; // Extract time portion, ignoring timezone

        // Create the formatted time string: "date time"
        const timeStr = `${dateKey} ${timeon}`;

        // Push to both arrays
        optionnewon.push(timeStr);
        optionnewendon.push(timeStr);
      });
    });

    // Sort optionnewon (ascending order) by full date-time
      optionnewon.sort((a, b) => {
      const fullDateA = new Date(a); // Convert full date-time string to Date object
      const fullDateB = new Date(b); // Convert full date-time string to Date object
      // return fullDateA - fullDateB; // Ascending order: compare full date-time
      return fullDateB - fullDateA; // Descending order: compare full date-time

    });

    // Sort optionnewendon (descending order) by full date-time
    optionnewendon.sort((a, b) => {
      const fullDateA = new Date(a); // Convert full date-time string to Date object
      const fullDateB = new Date(b); // Convert full date-time string to Date object
      // return fullDateB - fullDateA; // Descending order: compare full date-time
      return fullDateA - fullDateB; // Ascending order: compare full date-time

    });

    // Output the results
    // console.log('Sorted Ascending:', optionnewon);
    const formattedOptionNewEndon = optionnewendon.map((value, index) => ({
      index,
      value,
    }));
    const formattedOptionNewStarton = optionnewon.map((value, index) => ({
      index,
      value,
    }));

    this.setState({ treemenu: formattedOptionNewEndon, treemenurev: formattedOptionNewStarton });
    const lenght = formattedOptionNewEndon.length;
    this.setState({ lastindex: lenght, showModal: false, showModalNew: true });

    // default start/end to the earliest and latest from patientmenutree
    if (lenght > 0) {
      this.setState({ starttime: formattedOptionNewEndon[0].value, endtime: formattedOptionNewEndon[lenght - 1].value, inputValue: "1.5" });
    } else {
      const clickFallback = this.state.clickdata ? this.state.clickdata.replace(/%20/g, " ") : "";
      this.setState({ starttime: clickFallback, endtime: clickFallback, inputValue: "1.5" });
    }
    // console.log("st time", this.state.clickdata.replace("%20",' '));
    // console.log("ed time", this.state.clickdata);
  }
  handleInputChange(e) {
    this.setState({ inputValue: e.target.value });
  }
  handleInputPopupClose() {
    this.setState({ showInputPopup: false });
    this.setState({ showInvertorpopup: false });
    this.setState({ showAnlayseone: false });
    this.setState({ showAnalysetwo: false });
    this.setState({ showdatacopypopup: false });
    this.setState({ showAnalysethree: false });
    this.setState({ showAnalyzefour: false });
  }

  // Queue this analysis instead of running it now. Uses the same
  // code/server/time-range selection the OK button would; the BACKEND
  // queue worker executes entries strictly one at a time (analysisQueue.js
  // is just the API client).
  handleAddToQueue = async () => {
    const codeType = this.state.analyzeModal;
    const queueable = ["first-code", "second-code", "third-code", "fourth-code"];
    if (!queueable.includes(codeType)) return;

    let startdate = this.state.starttime || "";
    let enddate = this.state.endtime || "";
    if (!startdate || !enddate) {
      const fallback = this.state.clickdata ? this.state.clickdata.replace(/%20/g, " ") : "";
      if (!startdate) startdate = fallback;
      if (!enddate) enddate = fallback;
    }

    this.handleInputPopupClose();
    this.setState({ showModal: false, showModalNew: false });

    let message;
    try {
      const added = await enqueueAnalysis({
        userid: this.state.userid,
        name: this.props.patientName || this.state.userid,
        codeType,
        server: this.state.analyzeServer,
        startdate: startdate.replace(/%20/g, " "),
        enddate: enddate.replace(/%20/g, " "),
      });
      message = added
        ? "Added to analysis queue — the backend runs items one at a time. Track progress on the Analysis Dashboard."
        : "This patient is already in the analysis queue.";
    } catch (err) {
      // Backend queue routes missing/unreachable — say so, don't pretend.
      message =
        "Could not queue: " +
        ((err && err.message) || "backend unreachable") +
        ". Check the analysisQueue routes + worker on this web server.";
    }
    this.setState({ showSuccessModal: true, successMessage: message });
  };
  handleInputPopupOk() {
    // const inputvalue=this.state.inputValue
    // console.log(inputvalue)

    const userId = this.state.userid;
    
    // Ensure starttime and endtime are properly set
    let startTime = this.state.starttime ? this.state.starttime.replace(/ /g, "%20") : "";
    let endTime = this.state.endtime ? this.state.endtime.replace(/ /g, "%20") : "";
    
    // Fallback to clickdata if startTime or endTime are empty
    if (!startTime || !endTime) {
      const fallback = this.state.clickdata ? this.state.clickdata.replace(/ /g, "%20") : "";
      if (!startTime) startTime = fallback;
      if (!endTime) endTime = fallback;
    }
    
    if (this.state.inputValue) {
      this.setState({ showInputPopup: false });
      this.setState({ showInvertorpopup: false });
      this.setState({ showAnlayseone: false });
      this.setState({ showAnalysetwo: false });

      this.setState({ showAnalysethree: false });
      this.setState({ showAnalyzefour: false });
      this.setState({ showModalSpinner: true });
      this.setState({ showModalNew: false });
      // this.analyzeDataset.bind({ id: "temp2" });

      this.handleOpenModalSpinnerNew();

      const response = axios
        .post(`${apiUrl}api/common/amplitude_increase`, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),

          enddate: endTime.replace(/%20/g, " "),
          val: parseFloat(this.state.inputValue),
        })
        .then((res) => {
          this.handleCloseModal();
          this.setState({ showModalNew: false });
        })
        .catch((err) => {
          console.error('Amplitude increase API error:', err);
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          this.maybeReload(this.state.analyzeModal);
        });
    }
  }

  async handleSelectorOk() {
    const userId = this.state.userid;
    
    // Ensure starttime and endtime are properly set
    let startTime = this.state.starttime ? this.state.starttime.replace(/ /g, "%20") : "";
    let endTime = this.state.endtime ? this.state.endtime.replace(/ /g, "%20") : "";
    
    // Fallback to clickdata if startTime or endTime are empty
    if (!startTime || !endTime) {
      const fallback = this.state.clickdata ? this.state.clickdata.replace(/ /g, "%20") : "";
      if (!startTime) startTime = fallback;
      if (!endTime) endTime = fallback;
    }

    console.log("handleSelectorOk - Datetime values being used:", {
      startTime: startTime.replace(/%20/g, " "),
      endTime: endTime.replace(/%20/g, " "),
      selectedCode: this.state.analyzeModal
    });

    const selectedcode = this.state.analyzeModal;
    const progressCodes = ["first-code", "second-code", "third-code", "fourth-code", "analytics2"];
    this.setState({ showInputPopup: false });
    this.setState({ showInvertorpopup: false });
    this.setState({ showAnlayseone: false });
    this.setState({ showAnalysetwo: false });

    this.setState({ showAnalysethree: false });
    this.setState({ showAnalyzefour: false });
    this.setState({ showModalSpinner: true });
    this.setState({ showModalNew: false });

    // console.log(selectedcode)
    if (selectedcode == "inversion") {
      axios
        .post(`${apiUrl}api/common/explicitinvert`, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
        })
        .then((response) => {
          console.log("inversion");
          console.log("Response:", response);
          this.setState({ showModalSpinner: false });
          this.handleCloseModal();
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }

          // Logic to handle modal completion
          // Example: Set state to show a modal
        })
        .catch((error) => {
          console.error("Error:", error);
          // Start fallback polling — server may have started background job
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
          // Handle errors here, such as showing an error modal
          this.setState({ showModalSpinner: false });
          this.setState({ showModalNew: true });
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
    } else if (
      selectedcode === "first-code" &&
      this.state.starttime === this.state.endtime
    ) {
      console.log("start time", startTime, "endtime:", endTime);
      this.setState({ showModalSpinner: true });
      this.startProgressPolling(userId, "first-code");

      try {
        // reset server progress to 0 before starting
        await this.resetProgress(userId);
        let firstEndpoint;
        if (this.state.analyzeServer === "Server 2") {
          firstEndpoint = `${apiUrl4}api/common/Analyse_First_Modal2`;
        } else if (this.state.analyzeServer === "Server 1") {
          firstEndpoint = `${apiUrl4}api/common/First_code_Analyse`;
        } else if (this.state.analyzeServer === "Main Server") {
          firstEndpoint = `${apiUrl4}api/common/Analyse_First_Modal_Main_Server`;
        }
        const response = await axios.post(firstEndpoint, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        });
        console.log(response);
        this.setState({ showModalSpinner: false });
        this.handleCloseModal();
        if (!progressCodes.includes(selectedcode)) {
          window.location.reload();
        }
      } catch (error) {
        console.error("First Code Analysis API Error (Progress polling continues):", error);
        this.setState({ showModalSpinner: false, showModalNew: true });
      }

      console.log("FULL AI");
    } else if (
      selectedcode === "first-code" &&
      this.state.starttime !== this.state.endtime
    ) {
      this.setState({ showModalSpinner: false });
      this.startProgressPolling(userId, "first-code");
      
      await this.resetProgress(userId);
      let firstEndpointFull;
      if (this.state.analyzeServer === "Server 2") {
        firstEndpointFull = `${apiUrl4}api/common/Analyse_First_Modal2`;
      } else if (this.state.analyzeServer === "Server 1") {
        firstEndpointFull = `${apiUrl4}api/common/First_code_Analyse`;
      } else if (this.state.analyzeServer === "Main Server") {
        firstEndpointFull = `${apiUrl4}api/common/Analyse_First_Modal_Main_Server`;
      }
      axios.post(firstEndpointFull, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("First Code Full Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("FULL AI full analyse");
    } else if (
      selectedcode == "second-code" &&
      this.state.starttime === this.state.endtime
    ) {
      this.startProgressPolling(userId, "second-code");
      
      await this.resetProgress(userId);
      let secondEndpoint;
      if (this.state.analyzeServer === "Server 2") {
        secondEndpoint = `${apiUrl4}api/common/Analyse_classical_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        secondEndpoint = `${apiUrl4}api/common/Second_Code_Analysis`;
      } else if (this.state.analyzeServer === "Main Server") {
        secondEndpoint = `${apiUrl4}api/common/Analyse_classical_code_main_server`;
      } else {
        secondEndpoint = `${apiUrl4}api/common/Second_Code_Analysis`;
      }
      axios.post(secondEndpoint, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Second Code Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("CLASSIC AI");
    } else if (
      selectedcode === "second-code" &&
      this.state.starttime !== this.state.endtime
    ) {
      this.startProgressPolling(userId, "second-code");
      
      await this.resetProgress(userId);
      let secondEndpointFull;
      if (this.state.analyzeServer === "Server 2") {
        secondEndpointFull = `${apiUrl4}api/common/Analyse_classical_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        secondEndpointFull = `${apiUrl4}api/common/Second_Code_Analysis`;
      } else if (this.state.analyzeServer === "Main Server") {
        secondEndpointFull = `${apiUrl4}api/common/Analyse_classical_code_main_server`;
      } 
      axios.post(secondEndpointFull, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
          this.setState({ showModalSpinner: false });
          this.handleCloseModal();
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        })
        .catch((error) => {
          console.error("Second Code Full Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("CLASSIC AI full analyse");
    } else if (
      selectedcode == "third-code" &&
      this.state.starttime === this.state.endtime
    ) {
      this.setState({ showModalSpinner: false });
      this.startProgressPolling(userId, "third-code");
      
      await this.resetProgress(userId);
      let thirdEndpoint;
      if (this.state.analyzeServer === "Server 2") {
        thirdEndpoint = `${apiUrl4}api/common/Analyse_emergency_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        thirdEndpoint = `${apiUrl4}api/common/Analyse_emergency_code`;
      } else if (this.state.analyzeServer === "Main Server") {
        thirdEndpoint = `${apiUrl4}api/common/Analyse_emergency_code_Main_Server`;
      }
      axios.post(thirdEndpoint, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Third Code Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("third-code");
    } else if (
      selectedcode == "third-code" &&
      this.state.starttime !== this.state.endtime
    ) {
      this.setState({ showModalSpinner: false });
      this.startProgressPolling(userId, "third-code");
      
      await this.resetProgress(userId);
      let thirdEndpointFull;
      if (this.state.analyzeServer === "Server 2") {
        thirdEndpointFull = `${apiUrl4}api/common/Analyse_emergency_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        thirdEndpointFull = `${apiUrl4}api/common/Analyse_emergency_code`;
      } else if (this.state.analyzeServer === "Main Server") {
        thirdEndpointFull = `${apiUrl4}api/common/Analyse_emergency_code_Main_Server`;
      }
      axios.post(thirdEndpointFull, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Third Code Full Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("third-code full analayse");
    } else if (selectedcode == "fourth-code") {
      this.setState({ showModalSpinner: false });
      this.startProgressPolling(userId, "fourth-code");
      
      await this.resetProgress(userId);
      let fourthEndpoint;
      if (this.state.analyzeServer === "Server 2") {
        fourthEndpoint = `${apiUrl4}api/common/Analyse_negative_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        fourthEndpoint = `${apiUrl4}api/common/Analyse_negative_code`;
      } else if (this.state.analyzeServer === "Main Server") {
        fourthEndpoint = `${apiUrl4}api/common/Analyse_negative_code_Main_Server`;
      } 
      axios.post(fourthEndpoint, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Fourth Code Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("fourth-code" && this.state.starttime === this.state.endtime);
    } else if (
      selectedcode == "fourth-code" &&
      this.state.starttime !== this.state.endtime
    ) {
      this.setState({ showModalSpinner: false });
      this.startProgressPolling(userId, "fourth-code");
      
      let fourthEndpointFull;
      if (this.state.analyzeServer === "Server 2") {
        fourthEndpointFull = `${apiUrl4}api/common/Analyse_negative_code_server2`;
      } else if (this.state.analyzeServer === "Server 1") {
        fourthEndpointFull = `${apiUrl4}api/common/Analyse_negative_code`;
      } else if (this.state.analyzeServer === "Main Server") {
        fourthEndpointFull = `${apiUrl4}api/common/Analyse_negative_code_Main_Server`;
      } else {
        fourthEndpointFull = `${apiUrl4}api/common/Analyse_negative_code`;
      }
      axios.post(fourthEndpointFull, {
          userid: userId,
          startdate: startTime.replace(/%20/g, " "),
          enddate: endTime.replace(/%20/g, " "),
          analyzeServer: this.state.analyzeServer,
        })
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.error("Fourth Code Full Analysis API Error (Progress polling continues):", error);
          try {
            this.startProgressPolling(userId, selectedcode, 2000);
          } catch (e) {
            console.error('Fallback polling start failed:', e);
          }
        })
        .finally(() => {
          this.setState({ showModalSpinner: false });
          if (!progressCodes.includes(selectedcode)) {
            window.location.reload();
          }
        });
      console.log("fourth-code full analyse");
    } else if (selectedcode == "datacopy") {
      this.setState({ showModalSpinner: false });

      console.log("userid", userId);
      console.log("starttime", startTime.replace(/%20/g, " "));
      console.log("endtime", endTime.replace(/%20/g, " "));
      console.log("correctTime", this.state.correctTime);

      const starttime = startTime.replace(/%20/g, " ");
      const endtimes = endTime.replace(/%20/g, " ");
      const correcttime = this.state.correctTime;

      this.setState({ showLoading: true }); // Show loading indicator
      this.setState({ showModalSpinner: false });

      try {
        const response = await axios.post(`${apiUrl}api/common/data-copy-run`, {
          userid: userId,
          starttime,
          endtime: endtimes,
          correcttime: correcttime,
        });

        console.log("Data copy successful:", response.data);

        // Close the popup/modal on success
        this.setState({ showdatacopypopup: false });
      } catch (error) {
        console.error(
          "Error during data copy:",
          error.response ? error.response.data : error.message
        );

        // Show popup/modal on failure
        this.setState({ showdatacopypopup: true });
      } finally {
        this.setState({ showLoading: false }); // Hide loading indicator
        this.maybeReload(this.state.analyzeModal);
      }
    } else if (selectedcode === "analytics2") {
      this.setState({ showModalNew: false });
      try {
        // Reset server-side progress to 0 before starting analysis
        await this.resetProgress(userId);
        this.startProgressPolling(userId,"analytics2", 2000);
        this.setState({
          showProgressModal : true,
          showModalSpinner : false,
        });

        // Call the analysis API — ensure start/end are present (fallback to clickdata)
        const fallback = this.state.clickdata ? this.state.clickdata.replace(/%20/g, " ") : "";
        const startdate = startTime && startTime.trim() !== "" ? startTime.replace(/%20/g, " ") : fallback;
        const enddate = endTime && endTime.trim() !== "" ? endTime.replace(/%20/g, " ") : fallback;

        await axios.post(
          `${apiUrl4}api/common/Analyse_New_Modal1`,
          {
            userid: userId,
            databaseid: this.state.clickdata,
            startdate,
            enddate,
          },
          { timeout: 5 * 60 * 1000 }
        );

    // ❗ Do NOT stop polling here
    // Progress modal will close automatically when progress reaches 100%

  } catch (error) {
    console.error("Analytics2 start error:", error);
    this.stopProgressPolling();
    this.setState({
      showModalNew : true,
      showModalSpinner : false,
      showProgressModal : false,
    });
  }

  return;
  }
}


  handleDeletePopupClose=()=> {
    this.setState({ showDeletePopup: false });
  };

  deleteVerify=async(e) => {
    const response = await axios.get(
      `${apiUrl}api/common/patinentmenutreeNew?userid=${this.state.userid}`
    );
    const treemenu = response.data;
    let optionnewon = []; // For ascending order
    let optionnewendon = []; // For descending order

    // Iterate over each date group in treemenu
    Object.keys(treemenu).forEach((dateKey) => {
      treemenu[dateKey].forEach((entry) => {
        const MainTimeon = entry.date.split("T");
        const timeon = MainTimeon[1].split("+")[0]; // Extract time portion, ignoring timezone

        // Create the formatted time string: "date time"
        const timeStr = `${dateKey} ${timeon}`;

        // Push to both arrays
        optionnewon.push(timeStr);
        optionnewendon.push(timeStr);
      });
    });

    // Sort optionnewon (ascending order) by full date-time
    optionnewon.sort((a, b) => {
      const fullDateA = new Date(a); // Convert full date-time string to Date object
      const fullDateB = new Date(b); // Convert full date-time string to Date object
      return fullDateA - fullDateB; // Ascending order: compare full date-time
    });

    // Sort optionnewendon (descending order) by full date-time
    optionnewendon.sort((a, b) => {
      const fullDateA = new Date(a); // Convert full date-time string to Date object
      const fullDateB = new Date(b); // Convert full date-time string to Date object
      return fullDateB - fullDateA; // Descending order: compare full date-time
    });

    const formattedOptionNewEndon = optionnewendon.map((value, index) => ({
      index,
      value,
    }));
    const formattedOptionNewStarton = optionnewon.map((value, index) => ({
      index,
      value,
    }));

    this.setState({ treemenu: formattedOptionNewEndon });
    this.setState({ treemenurev: formattedOptionNewStarton });
    this.setState({ starttime: this.state.clickdata.replace("%20", " ") });
    this.setState({ endtime: this.state.clickdata.replace("%20", " ") });
    this.setState({ showDeletePopup: true });
  }

  handleDeletePopupOk=() => {
    if (window.confirm("Do you want to delete this Dataset?")) {
      console.log("remove all");

      var userid = this.state.userid;
      const starttime = this.state.starttime;
      const endtime = this.state.endtime;

      axios
        .post(`${apiUrl}api/common/explicit-delete`, {
          userid: userid,
          startdate: starttime.replace(/%20/g, " "),
          enddate: endtime.replace(/%20/g, " "),
        })
        .then((res) => {
          axios
            .get(`${apiUrl}api/common/getLatestDatabaseId?userid=${userid}`)
            .then((res) => {
              var latestDatabaseid = res.data;
              axios
                .get(
                  `${apiUrl}api/patients/getLatestDatabaseId?userid=${userid}&latestDatabaseid=${latestDatabaseid}`
                )
                .then((res) => {
                  console.log("Removed");
                  this.handleCloseModal();
                  if (window.location.href.includes("verifier-chart")) {
                    // window.location.href =
                    //   "/verifier-chart/" + userid + "/" + latestDatabaseid;
                  } else if (
                    window.location.href.includes("verifier-unanalysed")
                  ) {
                    // window.location.href =
                    //   "/verifier-unanalysed/" + userid + "/" + latestDatabaseid;
                  } else {
                    console.log(
                      "The URL does not contain 'verifier-chart' or 'verifier-unanalysed'"
                    );
                  }
                })
                .catch((err) => {
                  //      console.log(err);
                });
            })
            .catch((err) => {
              //        console.log(err);
            });
        })
        .catch((err) => {
          //      console.log(err);
        });
    }
    this.setState({ showDeletePopup: false });
  }

  // Start polling progress for specific analysis codes
  // intervalMs: optional polling frequency in milliseconds (default 1000ms)
  startProgressPolling = async(userId, codeType, intervalMs = 2000)=> {
    // Only show progress modal for these specific analysis types
    const allowedCodeTypes = ["first-code", "second-code", "third-code", "fourth-code", "analytics2"];
    const shouldShowProgress = allowedCodeTypes.includes(codeType);

    // If codeType should not show progress, skip starting polling entirely
    if (!shouldShowProgress) {
      console.log(`Skipping progress polling for codeType=${codeType}`);
      return;
    }

    // clear any existing polling first
    if (this.state.progressInterval) {
      console.log('Clearing existing progressInterval before starting new one');
      clearInterval(this.state.progressInterval);
    }
    // Hide lightweight spinner and show the full progress modal when appropriate
    // Record start time so we don't auto-close the modal immediately if the
    // server occasionally returns 100% before the analysis actually completes.
    // Also ensure any other UI modals/popups are closed so only the progress
    // modal is shown while analysis runs.
    const baseState = {
      showModalSpinner: false,
      showProgressModal: shouldShowProgress,
      currentProgress: 0,
      progressComplete: false,
      // Always show percent while polling so UI updates are visible
      showProgressPercent: true,
      progressStartTime: Date.now(),
    };

    if (shouldShowProgress) {
      Object.assign(baseState, {
        showModal: false,
        showModalNew: false,
        showAnlayseone: false,
        showAnalysetwo: false,
        showAnalysethree: false,
        showAnalyzefour: false,
        showInputPopup: false,
        showInvertorpopup: false,
        showdatacopypopup: false,
      });
    }

    this.setState(baseState);
    console.log(`startProgressPolling userId=${userId} codeType=${codeType} intervalMs=${intervalMs}`);

    // Do an immediate fetch so UI shows progress promptly, then start interval
    const fetchAndHandle = async () => {
      try {
        const url = `${apiUrl}api/common/getProgressStatus/${userId}`;
        console.log(`Fetching progress URL: ${url}`);
        const response = await axios.get(url);
        const progress = parseInt(response.data && response.data.progress, 10) || 0;
        // Always update currentProgress so UI and console reflect latest value
        this.setState({ currentProgress: progress });
        console.log(`Progress update for user=${userId} code=${codeType}: ${progress}%`);

        if (progress >= 100) {
          const minCloseDelayMs = 2000;
          const elapsed = this.state.progressStartTime ? Date.now() - this.state.progressStartTime : 0;
          if (elapsed < minCloseDelayMs) {
            this.setState({ currentProgress: 100 });
            console.log(`Progress at 100% too soon for user=${userId} code=${codeType}; elapsed=${elapsed}ms`);
            return false; // continue polling
          } else {
            console.log(`Progress reached 100% for user=${userId} code=${codeType}; stopping polling (immediate)`);
            this.setState({ progressInterval: null, progressComplete: true, currentProgress: 100, showProgressPercent: false, progressStartTime: null });
            setTimeout(() => this.setState({ showProgressModal: false }), 800);
            return true; // finished
          }
        }
        return false;
      } catch (error) {
        console.error('Error fetching progress:', error);
        return false;
      }
    };

    // run once immediately
    const finished = await fetchAndHandle();

    const interval = setInterval(async () => {
      try {
        const done = await fetchAndHandle();
        if (done) {
          clearInterval(this._progressInterval);
          this._progressInterval = null;
        }
      } catch (e) {
        console.error('Interval fetch error:', e);
      }
    }, intervalMs);

    // Store interval id on instance to avoid issues with setState batching
    this._progressInterval = interval;
    this.setState({ progressInterval: interval });
  }

  // Stop progress polling
  stopProgressPolling = () => {
    if (this._progressInterval) {
      console.log(`stopProgressPolling called for user=${this.state.userid}`);
      clearInterval(this._progressInterval);
      this._progressInterval = null;
    }
    if (this.state.progressInterval) {
      clearInterval(this.state.progressInterval);
    }
    // Stop polling but keep the modal visible (do not auto-close)
    this.setState({ progressInterval: null, showProgressPercent: false, progressStartTime: null });
  }

  // Close progress modal and clear polling
  handleCloseProgressModal=() => {
    if (this._progressInterval) {
      console.log(`handleCloseProgressModal called for user=${this.state.userid}`);
      clearInterval(this._progressInterval);
      this._progressInterval = null;
    }
    if (this.state.progressInterval) {
      clearInterval(this.state.progressInterval);
    }
    this.setState({ progressInterval: null, showProgressModal: false, showProgressPercent: false, progressStartTime: null });
  }

  analyzeDataset = async (e) => {
    var userid = this.state.userid;
    var databaseid = this.state.clickdata;
    if (e.currentTarget.id == "ai") {
      //  console.log("Analyse last");
      //   console.log('Select',e.currentTarget.id);
      window.analyzeLink =
        "/home/ubuntu/analysis_codes/ai_codes/analyze_last_correct.py";
    } else if (e.currentTarget.id == "hybrid") {
      // console.log('Select',e.currentTarget.id);
      window.analyzeLink =
        "/home/ubuntu/analysis_codes/emergency_code/analyze_last_correct.py";
    } else if (e.currentTarget.id == "classical") {
      //   console.log('Select',e.currentTarget.id);
      window.analyzeLink =
        "/home/ubuntu/analysis_codes/classical_code/analyze_last_correct.py";
    } else if (e.currentTarget.id == "temp1") {
      //    console.log('Select',e.currentTarget.id);
      window.analyzeLink =
        "/home/ubuntu/analysis_codes/negpeak/analyze_last_correct.py";
    } else if (e.currentTarget.id == "temp2") {
      //    console.log('Select',e.currentTarget.id);
      window.analyzeLink =
        "/home/ubuntu/analysis_codes/pvc_model/analyze_last_correct.py";
    } else if (e.currentTarget.id == "inversion") {
      console.log("Inversion single data");
      console.log("databaseid !!!!!!!!!!!!!!!!", databaseid);
      window.analyzeLink = "/home/ubuntu/web_analysis/single_invert.py";
    }
    //  console.log('window.analyzeLink',window.analyzeLink);
    // console.log('uid',userid);
    //  console.log('uid',databaseid);
    // console.log('&&databaseid=');
    if (window.analyzeLink != "") {
      var userid = this.state.userid;
      var databaseid = this.state.clickdata;
      e.currentTarget.innerHTML = "Analyzing...";
      //const userid = this.props.match.params.userid;
      this.handleCloseModalNew();
      // Reset server-side progress and start polling while analysis runs
      try {
        await this.resetProgress(userid);
        // map clicked id to a code type for the progress modal
        let codeType = null;
        if (e.currentTarget && e.currentTarget.id) {
          const id = e.currentTarget.id;
          if (id === "ai" || id === "temp2") codeType = "first-code";
          else if (id === "classical") codeType = "second-code";
          else if (id === "hybrid") codeType = "third-code";
          else if (id === "temp1") codeType = "fourth-code";
          else if (id === "analytics2") codeType = "analytics2";
        }
        this.startProgressPolling(userid, codeType, 2000);

        this.handleOpenModalSpinnerNew();

        axios
          .get(
            "https://web.mybiocalculus.com/html/welcome/analyzeDataset/?userid=" +
              userid +
              "&&databaseid=" +
              databaseid +
              "&&url=" +
              window.analyzeLink
          )
          .then((res) => {
            console.log("database analys");
            console.log(
              "https://web.mybiocalculus.com/html/welcome/analyzeDataset/?userid=" +
                userid +
                "&&databaseid=" +
                databaseid +
                "&&url=" +
                window.analyzeLink
            );
            console.log(res.data);
            console.log(window.analyzeLink);
            // keep progress modal open; spinner can be closed
            this.handleCloseModalSpinnerNew();
          })
          .catch((err) => {
            console.error('analyzeDataset start error:', err);
            // stop spinner and polling on error
            this.handleCloseModalSpinnerNew();
            this.stopProgressPolling();
          });
      } catch (err) {
        console.error('Failed to start analysis polling:', err);
        this.handleCloseModalSpinnerNew();
      }
    }
  }
  /* _onSelect(e)
  {
  
    if(e.value=='RPeaks')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/rpeaks_codes/analyze_last_correct.py';
    }
    else if(e.value=='Classic')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/classic_peak/analyze_last_correct.py';
    }
    else if(e.value=='Classical')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/classical_code/analyze_last_correct.py';
    }
    else if(e.value=='Classic Negative')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/classic_negpeak/analyze_last_correct.py';
    }
    else if(e.value=='AI')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/ai_codes/analyze_last_correct.py';
    }
    else if(e.value=='AIcodes')
    {
        console.log('Select',e.value);
        window.analyzeLink='/home/biocalculusssh/web_analysis/saroja_aicodes/analyze_last_correct.py';
    }
   
  }
*/
  renderLoading = () => {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 1000,
        }}
      >
        <div style={{ textAlign: "center" }}>
          <p style={{ fontSize: "20px", color: "white", marginBottom: "20px" }}>
            Copying Data...
          </p>
          <div
            style={{ display: "flex", justifyContent: "center", gap: "5px" }}
          >
            {[...Array(5)].map((_, index) => (
              <div
                key={index}
                style={{
                  width: "10px",
                  height: "40px",
                  backgroundColor: "white",
                  animation: `bounce 1s infinite ease-in-out`,
                  animationDelay: `${index * 0.2}s`,
                }}
              ></div>
            ))}
          </div>
          <style>
            {`
                        @keyframes bounce {
                            0%, 100% {
                                transform: scaleY(1);
                            }
                            50% {
                                transform: scaleY(0.5);
                            }
                        }
                    `}
          </style>
        </div>
      </div>
    );
  }

  render = () => {
    if (this.state.showLoading) {
      return this.renderLoading(); // Render loading indicator when loading
    }
    /* const imageList = [{
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
},{
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}, {
  src: '../../dist/img/AI.png',
  width: 152,
  height: 102
}]; */
    const customStyles = {
      content: {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)", // Ensures perfect centering
        background: "transparent",
        border: "none", // Removes borders
        padding: 0, // Ensures no extra space around content
        display: "flex", // Aligns spinner properly
        justifyContent: "center", // Centers spinner horizontally
        alignItems: "center", // Centers spinner vertically
      },
      overlay: {
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Adds a semi-transparent overlay
      },
    };
    const customStylesNew = {
      content: {
        top: "38%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        border: "1px solid rgb(204, 204, 204)",
        background: "rgb(255, 255, 255)",
        overflow: "auto",
        borderRadius: "4px",
        outline: "none",
        padding: "20px",
        height: "45%",
        width: "35%",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
      },
    };
    const text = "Analyzing....";
    //  const options = [
    //        'RPeaks', 'Classic', 'Classical','Classic Negative', 'AI','AIcodes'
    //       ];
    //        const defaultOption = options[0];
    // console.log(this.state.showModal)
    return (
      <React.Fragment>
            <ReactModal isOpen={this.state.showModalSpinner || this.state.showProgressModal} style={customStyles}>
      <div style={{ textAlign: "center" }}>
        <AnalyzingSpinner
            progress={this.state.currentProgress}
            showPercent={this.state.showProgressPercent}
            size={100}
        />

        <div className="bounce-container" style={{ marginTop: "12px" }}>
          {text.split("").map((char, index) => (
            <span key={index} className="bounce-letter" style={{ animationDelay: `${index * 0.1}s` }}>
              {char}
            </span>
          ))}
        </div>
      </div>
    </ReactModal>

        {/* Progress Modal with Circular Progress */}
        {/* <ReactModal
          isOpen={this.state.showProgressModal}
          style={{
            content: {
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              background: "white",
              border: "1px solid #ddd",
              padding: "40px",
              borderRadius: "8px",
              width: "300px",
              textAlign: "center",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            },
            overlay: {
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            },
          }}
          contentLabel="Progress Modal"
        >
          <div>
            <h3 style={{ color: "#333", marginBottom: "20px" }}>Analyzing...!!!</h3>
            <div style={{ margin: "0 auto 10px", width: 220 }}>
              <AnalyzingSpinner
                progress={this.state.currentProgress}
                showPercent={this.state.showProgressPercent}
                size={140}
              />
            </div>
            <p style={{ color: "#666", fontSize: "14px" }}>
              Please wait while we process your data...
            </p>
          </div>
        </ReactModal> */}
       
        <ReactModal
          isOpen={this.state.showModal && !this.state.showProgressModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
          <React.Fragment>
            <div className="blog-pop-bg"></div>
            <div className="blog-pop-box">
              <button
                className="pull-right closeBtn"
                onClick={this.handleCloseModal}
              >
                &#10006;
              </button>

              <div className="fea pull-left" style={{ marginRight: "50px" }}>
                {this.state.startProp == undefined && (
                  <button style={{ border: "none" }}>
                    <img
                      onClick={this.openAnalyzemodal.bind(this)}
                      src="../../dist/img/blog-pop1.png"
                      alt=""
                    />
                  </button>
                )}
                {this.state.startProp != undefined && (
                  <button style={{ border: "none" }}>
                    <img
                      onClick={this.openAnalyzemodal.bind(this)}
                      src="../../../../../dist/img/blog-pop1.png"
                      alt=""
                    />
                  </button>
                )}
                <p style={{ marginLeft: "30%", fontSize: "25px" }}>Analyze</p>
              </div>
              <div className="fea pull-right" style={{ marginLeft: "50px" }}>
                {this.state.startProp == undefined && (
                  <button style={{ border: "none" }}>
                    <img
                      onClick={this.deleteVerify.bind(this)}
                      src="../../dist/img/blog-pop2.png"
                      alt=""
                    />
                  </button>
                )}
                {this.state.startProp != undefined && (
                  <button style={{ border: "none" }}>
                    <img
                      onClick={this.deleteVerify.bind(this)}
                      src="../../../../../dist/img/blog-pop2.png"
                      alt=""
                    />
                  </button>
                )}
                <p style={{ marginLeft: "40%", fontSize: "25px" }}>DELETE</p>
              </div>
              <br />
            </div>
          </React.Fragment>
        </ReactModal>
        <ReactModal
          isOpen={this.state.showModalNew && !this.state.showProgressModal}
          style={customStylesNew}
          contentLabel="Analyze Modal"
        >
          <React.Fragment>
            <div className="blog-pop-box">
              <button
                className="pull-right closeBtn"
                onClick={this.handleCloseModalNew}
              >
                &#10006;
              </button>

              <div className="container col-md-12">
                <div className="row" style={{ marginTop: "15%" }}>
                  <div className="col-md-4" style={{ textAlign: "center" }}>
                    <button style={{ border: "none", display: "block", width: "100%" }}>
                      <img
                        id="ai"
                        onClick={(e) =>
                          this.setState({
                            showAnlayseone: true,
                            analyzeModal: "first-code",
                          })
                        }
                        src="../../dist/img/AI.png"
                        alt="FULL AI"
                        style={{ width: "100%", height: "auto", maxWidth: "150px" }}
                      />
                      <div style={{ marginTop: "10px", fontWeight: "bold", color: "black", fontSize: "14px" }}>
                        FULL AI
                      </div>
                    </button>
                  </div>

                  <div className="col-md-4" style={{ textAlign: "center" }}>
                    <button style={{ border: "none", display: "block", width: "100%" }}>
                      <img
                        id="classical"
                        onClick={(e) =>
                          this.setState({
                            showAnalysetwo: true,
                            analyzeModal: "second-code",
                          })
                        }
                        src="../../dist/img/CLASSICAL.png"
                        alt="CLASSIC AI"
                        style={{ width: "100%", height: "auto", maxWidth: "150px" }}
                      />
                      <div style={{ marginTop: "10px", fontWeight: "bold", color: "black", fontSize: "14px" }}>
                        CLASSIC AI
                      </div>
                    </button>
                  </div>

                  <div className="col-md-4" style={{ textAlign: "center" }}>
                    <button style={{ border: "none", display: "block", width: "100%" }}>
                      <img
                        id="hybrid"
                        onClick={(e) =>
                          this.setState({
                            showAnalysethree: true,
                            analyzeModal: "third-code",
                          })
                        }
                        src="../../dist/img/HYBRID.png"
                        alt="EMG CODE"
                        style={{ width: "100%", height: "auto", maxWidth: "150px" }}
                      />
                      <div style={{ marginTop: "10px", fontWeight: "bold", color: "black", fontSize: "14px" }}>
                        EMG CODE
                      </div>
                    </button>
                  </div>
                </div>
                <div className="row" style={{ marginTop: "20px" }}>
                  <div className="col-md-4" style={{ textAlign: "center" }}>
                    <button style={{ border: "none", display: "block", width: "100%" }}>
                      <img
                        id="temp1"
                        onClick={(e) =>
                          this.setState({
                            showAnalyzefour: true,
                            analyzeModal: "fourth-code",
                          })
                        }
                        src="../../dist/img/TEMPLATE1.png"
                        alt="NEGPEAK AI"
                        style={{ width: "100%", height: "auto", maxWidth: "150px" }}
                      />
                      <div style={{ marginTop: "10px", fontWeight: "bold", color: "black", fontSize: "14px" }}>
                        NEGPEAK AI
                      </div>
                    </button>
                  </div>

                  <div className="col-md-4" style={{ textAlign: "center" }}>
                    <button style={{ border: "none", display: "block", width: "100%" }}>
                      <img
                        id="temp2"
                        onClick={async (e) => { await this.openAnalyzemodal(); this.setState({ showInputPopup: true }); }}
                        src="../../dist/img/TEMPLATE2.png"
                        alt="AMP INCREASE"
                        style={{ width: "100%", height: "auto", maxWidth: "150px" }}
                      />
                      <div style={{ marginTop: "10px", fontWeight: "bold", color: "black", fontSize: "14px" }}>
                        AMP INCREASE
                      </div>
                    </button>
                  </div>
                  <div className="col-md-4" style={{ textAlign: "center" }}>
                    <button style={{ border: "none", display: "block", width: "100%" }}>
                      <img
                        id="inversion"
                        onClick={() =>
                          this.setState({
                            showInvertorpopup: true,
                            analyzeModal: "inversion",
                          })
                        }
                        src="../../dist/img/inversion.png"
                        alt="Inversion"
                        style={{ width: "100%", height: "auto", maxWidth: "150px" }}
                      />
                      <div style={{ marginTop: "10px", fontWeight: "bold", color: "black", fontSize: "14px" }}>
                        Inversion
                      </div>
                    </button>
                  </div>
                </div>
                <div className="row" style={{ marginTop: "20px" }}>
                  <div className="col-md-4" style={{ textAlign: "center" }}>
                    <button style={{ border: "none", display: "block", width: "100%" }}>
                      <img
                        id="datacopy"
                        onClick={(e) => {
                          this.setState({
                            showdatacopypopup: true,
                            analyzeModal: "datacopy",
                          });
                        }}
                        src="../../dist/img/datacopy.webp"
                        alt="Data Copy"
                        style={{ width: "100%", height: "auto", maxWidth: "150px", minHeight: "100px" }}
                      />
                      <div style={{ marginTop: "10px", fontWeight: "bold", color: "black", fontSize: "14px" }}>
                        Data Copy
                      </div>
                    </button>
                  </div>
                  <div className="col-md-4" style={{ textAlign: "center" }}>
                    <button style={{ border: "none", display: "block", width: "100%" }}>
                      <img
                        id="analytics2"
                        onClick={() =>
                          this.setState({
                            showAnlayseone: true,
                            analyzeModal: "analytics2",
                          })
                        }
                        src="../../dist/img/AI.png"
                        alt="Analytics 2"
                        style={{ width: "100%", height: "auto", maxWidth: "150px", minHeight: "100px" }}
                      />
                      <div style={{ marginTop: "10px", fontWeight: "bold", color: "black", fontSize: "14px" }}>
                        Analytics 2
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        </ReactModal>
        {/* AMP INCREASE modal */}
        <ReactModal isOpen={this.state.showInputPopup && !this.state.showProgressModal} style={customStylesNew}>
          <div style={{ display: "block", padding: "10px" }}>
            <div style={{ marginTop: "8px" }}>
              <label style={{ color: "black", padding: "5px" }}>Start Time:</label>
              <select
                style={{
                  color: "black",
                  padding: "5px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  marginTop: "10px",
                  width: "100%",
                  fontSize: "16px",
                  backgroundColor: "white",
                }}
                value={this.state.starttime}
                onChange={(e) => this.setState({ starttime: e.target.value })}
              >
                {Array.isArray(this.state.treemenu) &&
                  this.state.treemenu.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.value || "No Value"}
                    </option>
                  ))}
              </select>
            </div>

            <div style={{ marginTop: "12px" }}>
              <label style={{ color: "black", padding: "5px" }}>End Time:</label>
              <select
                style={{
                  color: "black",
                  padding: "5px",
                  borderRadius: "4px",
                  border: "1px solid #ccc",
                  marginTop: "10px",
                  width: "100%",
                  fontSize: "16px",
                  backgroundColor: "white",
                }}
                value={this.state.endtime}
                onChange={(e) => this.setState({ endtime: e.target.value })}
              >
                {Array.isArray(this.state.treemenurev) &&
                  this.state.treemenurev.map((item, index) => (
                    <option key={index} value={item.value}>
                      {item.label || item.value || "No Label"}
                    </option>
                  ))}
              </select>
            </div>

            <label style={{ color: "black", padding: "5px", marginTop: "12px", display: "block" }}>
              Enter the point to increase Amp?
            </label>
            <input
              type="text"
              value={this.state.inputValue}
              onChange={this.handleInputChange.bind(this)}
              style={{ width: "100%", padding: "8px", marginTop: "8px", boxSizing: "border-box" }}
            />

            <div style={{ display: "flex", justifyContent: "center", marginTop: "15px" }}>
              <button
                style={{ padding: "8px 16px", backgroundColor: "#4CAF50", color: "white", border: "none", borderRadius: "4px", cursor: "pointer", marginRight: "8px" }}
                onClick={this.handleInputPopupOk.bind(this)}
              >
                OK
              </button>
              <button
                style={{ padding: "8px 16px", backgroundColor: "#f44336", color: "white", border: "none", borderRadius: "4px", cursor: "pointer" }}
                onClick={this.handleInputPopupClose.bind(this)}
              >
                Cancel
              </button>
            </div>
          </div>
        </ReactModal>
        {/* end AMP INCREASE // start invert */}
        <ReactModal
          isOpen={this.state.showInvertorpopup}
          style={customStylesNew}
        >
          {/* First Select Tag */}
          <div style={{ marginTop: "15px" }}>
            Invert
            <label style={{ color: "black", padding: "5px" }}>
              Start Time:
            </label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.starttime}
              onChange={(e) => this.setState({ starttime: e.target.value })}
            >
              {Array.isArray(this.state.treemenu) &&
                this.state.treemenu.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.value || "No Value"}
                  </option>
                ))}
            </select>
          </div>

          {/* Second Select Tag */}
          <div style={{ marginTop: "15px" }}>
            <label style={{ color: "black", padding: "5px" }}>End Time:</label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.endtime}
              onChange={(e) => this.setState({ endtime: e.target.value })}
            >
              {Array.isArray(this.state.treemenurev) &&
                this.state.treemenurev.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label || item.value || "No Label"}
                  </option>
                ))}
            </select>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <button
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={this.handleSelectorOk.bind(this)}
            >
              OK
            </button>
            {["first-code", "second-code", "third-code", "fourth-code"].includes(
              this.state.analyzeModal
            ) && (
              <button
                title="Run later, one at a time, via the analysis queue"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#0a8aa0",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                onClick={this.handleAddToQueue}
              >
                + Queue
              </button>
            )}
            <button
              className="primary"
              style={{
                padding: "10px 20px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={this.handleInputPopupClose.bind(this)}
            >
              Cancel
            </button>
          </div>
        </ReactModal>
        {/* end invert // start analyze FULL AI */}
        <ReactModal isOpen={this.state.showAnlayseone} style={customStylesNew}>
          {/* First Select Tag */}
          <div style={{ marginTop: "15px" }}>
            FULL AI
            {this.state.analyzeModal !== "analytics2" && (
              <div style={{ marginTop: "10px" }}>
                <label style={{ color: "black", padding: "5px", display: "block" }}>Select Server:</label>
                <select
                  value={this.state.analyzeServer}
                  onChange={(e) => this.setState({ analyzeServer: e.target.value })}
                  style={{ width: "100%", padding: "8px", fontSize: "14px", marginTop: "6px",backgroundColor:"white",color:"black" }}
                >
                  <option style={{color:"black"}}>Server 1</option>
                  <option style={{color:"black"}}>Server 2</option>
                  <option style={{color:"black"}}>Main Server</option>
                </select>
              </div>
            )}
            <label style={{ color: "black", padding: "5px" }}>
              Start Time:
            </label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.starttime}
              onChange={(e) => this.setState({ starttime: e.target.value })}
            >
              {Array.isArray(this.state.treemenu) &&
                this.state.treemenu.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.value || "No Value"}
                  </option>
                ))}
            </select>
          </div>

          {/* Second Select Tag */}
          <div style={{ marginTop: "15px" }}>
            <label style={{ color: "black", padding: "5px" }}>End Time:</label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.endtime}
              onChange={(e) => this.setState({ endtime: e.target.value })}
            >
              {Array.isArray(this.state.treemenurev) &&
                this.state.treemenurev.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label || item.value || "No Label"}
                  </option>
                ))}
            </select>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <button
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={this.handleSelectorOk.bind(this)}
            >
              OK
            </button>
            {["first-code", "second-code", "third-code", "fourth-code"].includes(
              this.state.analyzeModal
            ) && (
              <button
                title="Run later, one at a time, via the analysis queue"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#0a8aa0",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                onClick={this.handleAddToQueue}
              >
                + Queue
              </button>
            )}
            <button
              className="primary"
              style={{
                padding: "10px 20px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={this.handleInputPopupClose.bind(this)}
            >
              Cancel
            </button>
          </div>
        </ReactModal>
        {/* end analyze FULL AI // start analyze CLASSIC AI */}
        <ReactModal isOpen={this.state.showAnalysetwo} style={customStylesNew}>
          {/* First Select Tag */}
          <div style={{ marginTop: "15px" }}>
            CLASSIC AI
            <div style={{ marginTop: "10px" }}>
              <label style={{ color: "black", padding: "5px", display: "block" }}>Select Server:</label>
              <select
                value={this.state.analyzeServer}
                onChange={(e) => this.setState({ analyzeServer: e.target.value })}
                style={{ width: "100%", padding: "8px", fontSize: "14px", marginTop: "6px",backgroundColor:"white",color:"black" }}
              >
                <option style={{color:"black"}}>Server 1</option>
                <option style={{color:"black"}}>Server 2</option>
                <option style={{color:"black"}}>Main Server</option>
              </select>
            </div>
            <label style={{ color: "black", padding: "5px" }}>
              Start Time:
            </label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.starttime}
              onChange={(e) => this.setState({ starttime: e.target.value })}
            >
              {Array.isArray(this.state.treemenu) &&
                this.state.treemenu.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.value || "No Value"}
                  </option>
                ))}
            </select>
          </div>

          {/* Second Select Tag */}
          <div style={{ marginTop: "15px" }}>
            <label style={{ color: "black", padding: "5px" }}>End Time:</label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.endtime}
              onChange={(e) => this.setState({ endtime: e.target.value })}
            >
              {Array.isArray(this.state.treemenurev) &&
                this.state.treemenurev.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label || item.value || "No Label"}
                  </option>
                ))}
            </select>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <button
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={this.handleSelectorOk.bind(this)}
            >
              OK
            </button>
            {["first-code", "second-code", "third-code", "fourth-code"].includes(
              this.state.analyzeModal
            ) && (
              <button
                title="Run later, one at a time, via the analysis queue"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#0a8aa0",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                onClick={this.handleAddToQueue}
              >
                + Queue
              </button>
            )}
            <button
              className="primary"
              style={{
                padding: "10px 20px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={this.handleInputPopupClose.bind(this)}
            >
              Cancel
            </button>
          </div>
        </ReactModal>
        {/* end analyze CLASSIC AI // start analyze EMG CODE */}
        <ReactModal
          isOpen={this.state.showAnalysethree}
          style={customStylesNew}
        >
          {/* First Select Tag */}
          <div style={{ marginTop: "15px" }}>
            EMG CODE
            <div style={{ marginTop: "10px" }}>
              <label style={{ color: "black", padding: "5px", display: "block" }}>Select Server:</label>
              <select
                value={this.state.analyzeServer}
                onChange={(e) => this.setState({ analyzeServer: e.target.value })}
                style={{ width: "100%", padding: "8px", fontSize: "14px", marginTop: "6px",backgroundColor:"white",color:"black" }}
              >
                <option style={{color:"black"}}>Server 1</option>
                <option style={{color:"black"}}>Server 2</option>
                <option style={{color:"black"}}>Main Server</option>
              </select>
            </div>
            <label style={{ color: "black", padding: "5px" }}>
              Start Time:
            </label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.starttime}
              onChange={(e) => this.setState({ starttime: e.target.value })}
            >
              {Array.isArray(this.state.treemenu) &&
                this.state.treemenu.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.value || "No Value"}
                  </option>
                ))}
            </select>
          </div>

          {/* Second Select Tag */}
          <div style={{ marginTop: "15px" }}>
            <label style={{ color: "black", padding: "5px" }}>End Time:</label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.endtime}
              onChange={(e) => this.setState({ endtime: e.target.value })}
            >
              {Array.isArray(this.state.treemenurev) &&
                this.state.treemenurev.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label || item.value || "No Label"}
                  </option>
                ))}
            </select>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <button
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={this.handleSelectorOk.bind(this)}
            >
              OK
            </button>
            {["first-code", "second-code", "third-code", "fourth-code"].includes(
              this.state.analyzeModal
            ) && (
              <button
                title="Run later, one at a time, via the analysis queue"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#0a8aa0",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                onClick={this.handleAddToQueue}
              >
                + Queue
              </button>
            )}
            <button
              className="primary"
              style={{
                padding: "10px 20px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={this.handleInputPopupClose.bind(this)}
            >
              Cancel
            </button>
          </div>
        </ReactModal>
        {/* end analyze EMG CODE // start analyze NEGPEAK AI */}
        <ReactModal isOpen={this.state.showAnalyzefour} style={customStylesNew}>
          {/* First Select Tag */}
          <div style={{ marginTop: "15px" }}>
            NEGPEAK AI
            <div style={{ marginTop: "10px" }}>
              <label style={{ color: "black", padding: "5px", display: "block" }}>Select Server:</label>
              <select
                value={this.state.analyzeServer}
                onChange={(e) => this.setState({ analyzeServer: e.target.value })}
                style={{ width: "100%", padding: "8px", fontSize: "14px", marginTop: "6px",backgroundColor:"white",color:"black" }}
              >
                <option style={{color:"black"}}>Server 1</option>
                <option style={{color:"black"}}>Server 2</option>
                <option style={{color:"black"}}>Main Server</option>
              </select>
            </div>
            <label style={{ color: "black", padding: "5px" }}>
              Start Time:
            </label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.starttime}
              onChange={(e) => this.setState({ starttime: e.target.value })}
            >
              {Array.isArray(this.state.treemenu) &&
                this.state.treemenu.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.value || "No Value"}
                  </option>
                ))}
            </select>
          </div>

          {/* Second Select Tag */}
          <div style={{ marginTop: "15px" }}>
            <label style={{ color: "black", padding: "5px" }}>End Time:</label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.endtime}
              onChange={(e) => this.setState({ endtime: e.target.value })}
            >
              {Array.isArray(this.state.treemenurev) &&
                this.state.treemenurev.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label || item.value || "No Label"}
                  </option>
                ))}
            </select>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <button
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={this.handleSelectorOk.bind(this)}
            >
              OK
            </button>
            {["first-code", "second-code", "third-code", "fourth-code"].includes(
              this.state.analyzeModal
            ) && (
              <button
                title="Run later, one at a time, via the analysis queue"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#0a8aa0",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                onClick={this.handleAddToQueue}
              >
                + Queue
              </button>
            )}
            <button
              className="primary"
              style={{
                padding: "10px 20px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={this.handleInputPopupClose.bind(this)}
            >
              Cancel
            </button>
          </div>
        </ReactModal>
        {/* end analyze NEGPEAK AI */}
        <ReactModal isOpen={this.state.showDeletePopup} style={customStylesNew}>
          <div style={{ marginTop: "15px" }}>
            <label style={{ color: "black", padding: "5px" }}>
              Start Time:
            </label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.starttime}
              onChange={(e) => this.setState({ starttime: e.target.value })}
            >
              {Array.isArray(this.state.treemenu) &&
                this.state.treemenu.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.value || "No Value"}
                  </option>
                ))}
            </select>
          </div>

          <div style={{ marginTop: "15px" }}>
            <label style={{ color: "black", padding: "5px" }}>End Time:</label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.endtime}
              onChange={(e) => this.setState({ endtime: e.target.value })}
            >
              {Array.isArray(this.state.treemenurev) &&
                this.state.treemenurev.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label || item.value || "No Label"}
                  </option>
                ))}
            </select>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <button
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={this.handleDeletePopupOk}
            >
              OK
            </button>
            <button
              className="primary"
              style={{
                padding: "10px 20px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={this.handleDeletePopupClose}
            >
              Cancel
            </button>
          </div>
        </ReactModal>
        <ReactModal
          isOpen={this.state.showdatacopypopup}
          style={customStylesNew}
        >
          {/* First Select Tag */}
          <div style={{ marginTop: "15px", color: "black" }}>
            Time Correction: <br />
            <label style={{ color: "black", padding: "5px" }}>
              Start Time:
            </label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.starttime}
              onChange={(e) => this.setState({ starttime: e.target.value })}
            >
              {Array.isArray(this.state.treemenu) &&
                this.state.treemenu.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.value || "No Value"}
                  </option>
                ))}
            </select>
          </div>

          {/* Second Select Tag */}
          <div style={{ marginTop: "15px" }}>
            <label style={{ color: "black", padding: "5px" }}>End Time:</label>
            <select
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
                backgroundColor: "white",
              }}
              value={this.state.endtime}
              onChange={(e) => this.setState({ endtime: e.target.value })}
            >
              {Array.isArray(this.state.treemenurev) &&
                this.state.treemenurev.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.label || item.value || "No Label"}
                  </option>
                ))}
            </select>
          </div>

          {/* Input for Correct Time */}
          <div style={{ marginTop: "15px" }}>
            <label style={{ color: "black", padding: "5px" }}>
              Enter Correct Time:
            </label>
            <input
              type="text"
              style={{
                color: "black",
                padding: "5px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                marginTop: "10px",
                width: "100%",
                fontSize: "16px",
              }}
              value={this.state.correctTime || ""}
              onChange={(e) => this.setState({ correctTime: e.target.value })}
              placeholder="YYYY-MM-DD HH:MM:SS"
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <button
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
                marginRight: "10px",
              }}
              onClick={this.handleSelectorOk.bind(this)}
            >
              OK
            </button>
            {["first-code", "second-code", "third-code", "fourth-code"].includes(
              this.state.analyzeModal
            ) && (
              <button
                title="Run later, one at a time, via the analysis queue"
                style={{
                  padding: "10px 20px",
                  backgroundColor: "#0a8aa0",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                  marginRight: "10px",
                }}
                onClick={this.handleAddToQueue}
              >
                + Queue
              </button>
            )}
            <button
              className="primary"
              style={{
                padding: "10px 20px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
              onClick={this.handleInputPopupClose.bind(this)}
            >
              Cancel
            </button>
          </div>
        </ReactModal>
        <ReactModal
          isOpen={this.state.showSuccessModal}
          style={{
            content: {
              top: "50%",
              left: "50%",
              right: "auto",
              bottom: "auto",
              marginRight: "-50%",
              transform: "translate(-50%, -50%)",
              border: "1px solid #ccc",
              background: "#fff",
              borderRadius: "8px",
              padding: "30px",
              textAlign: "center",
            },
          }}
          contentLabel="Success Modal"
        >
          <h2 style={{ color: "#4CAF50" }}>Success</h2>
          <p>{this.state.successMessage}</p>
          <button
            style={{
              padding: "10px 20px",
              backgroundColor: "#4CAF50",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              marginTop: "20px",
            }}
            onClick={() => this.setState({ showSuccessModal: false })}
          >
            Close
          </button>
        </ReactModal>
      </React.Fragment>
    );
  }
}

export default AddModalComplete;
